import React, { lazy } from "react";
import { Base_Url } from "../../utils/apiUrl";

const Home = lazy(() => import("../../pages/Home"));
const Highlight = lazy(() => import("../../pages/Home/Highlight"));
const JoinTelegram = lazy(() => import("../../pages/WarrantMarket/JoinTelegram"));
const JoinMooCommunity = lazy(() => import("../../pages/WarrantMarket/JoinMooCommunity"));
const OvernightMarketWrap = lazy(() => import("../../pages/WarrantMarket/OvernightMarketWrap"));
const Highlights = lazy(() => import("../../pages/WarrantMarket/Highlight/Highlights"));
const PhotoDetail = lazy(() => import("../../pages/WarrantMarket/PhotoGallery/PhotoDetail"));
const Subscribe = lazy(() => import("../../pages/WarrantMarket/Subscribe"));
const WarrantHeros = lazy(() => import("../../pages/WarrantMarket/Activities/Warrant2015/"));
const WarrantWarriors = lazy(() => import("../../pages/WarrantMarket/Activities/Warrant2017/"));
const ImportantInformation = lazy(() => import("../../components/common/Footer/ImportantInformation"));
const PrivacyPolicy = lazy(() => import("../../components/common/Footer/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("../../components/common/Footer/TermsOfUse"));
const DisclaimerInfo = lazy(() => import("../../components/common/Footer/Disclaimer"));

const warrantMarketRoutes = [
  // Home
  {
    path: "/home",
    element: <Home />,
    title: "Malaysia Warrants | Trading Stocks and Index Warrants | Macquarie",
    description: "See today's top traded index and single stock structured warrants at Malaysia Warrants. Trading tools and stock market updates, all in one place.",
    keyword: "Malaysia warrants, structured warrants, Macquarie",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/home/highlight",
    element: <Highlight />,
    title: "Malaysia Warrants | Trading Stocks and Index Warrants | Macquarie",
  },
  {
    path: "/home/:id",
    element: <Home />,
    title: "Malaysia Warrants | Trading Stocks and Index Warrants | Macquarie",
    description: "See today's top traded index and single stock structured warrants at Malaysia Warrants. Trading tools and stock market updates, all in one place.",
    keyword: "Malaysia warrants, structured warrants, Macquarie",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
    renderFn: true,
  },
  // About
  {
    path: "/about/important-information",
    element: <ImportantInformation />,
    title: "Malaysia Warrants | Trading Stocks and Index Warrants | Macquarie",
    renderFn: true,
  },
  {
    path: "/about/privacy-policy",
    element: <PrivacyPolicy />,
    title: "Malaysia Warrants | Trading Stocks and Index Warrants | Macquarie",
    renderFn: true,
  },
  {
    path: "/about/terms-of-use",
    element: <TermsOfUse />,
    title: "Malaysia Warrants | Trading Stocks and Index Warrants | Macquarie",
    renderFn: true,
  },
  {
    path: "/about/disclaimer",
    element: <DisclaimerInfo />,
    title: "Malaysia Warrants | Trading Stocks and Index Warrants | Macquarie",
    renderFn: true,
  },
  // Warrant Market
  {
    path: "/moocommunity",
    element: <JoinMooCommunity />,
    title: "Join us on MooCommunity",
    ogUrl: `${Base_Url}/moocommunity`,
    ogType: "website",
    ogTitle: "Join the Malaysia Warrants Telegram channel",
    ogDescription: "Get timely updates on structured warrants as well as the foreign and local markets!",
    ogImage: `${Base_Url}/img/telegram/telegram.png`,
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/marketnews/news",
    element: <OvernightMarketWrap />,
    title: "Overnight market wrap | Malaysia Warrants | Macquarie",
    description: "Stay on top of the latest news in the global markets to ensure that you make the most informed decisions on any trading day.",
    keyword: "S&P 500 Index, US stocks, global markets",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/marketnews/highlight",
    element: <Highlights />,
    title: "Malaysia Warrants | Macquarie",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/marketnews/individualgallery",
    element: <PhotoDetail />,
    title: "Photo gallery | Malaysia Warrants | Macquarie",
    description: "Visit our photo gallery to get a closer look at all our recent events.",
    keyword: "Photos, Macquarie, malaysia warrants",
  },
  {
    path: "/marketnews/subscribe",
    element: <Subscribe />,
    title: "Subscribe |  Malaysia Warrants | Macquarie",
    description: "Subscribe to Macquarie's daily newsletter. Start each day with the inside scoop on what's happening in the warrants market.",
    keyword: "newsletter, malaysia warrants, subscribe",
    facebookDomain: "gysvbbpef4ffs8np35mfk6djt8dofq",
  },
  {
    path: "/marketnews/activities/hero/2015",
    element: <WarrantHeros />,
    title: "Warrant Hero 2015",
    ogType: "website",
    ogTitle: "Warrant Hero 2015",
    ogDescription: "Warrant Hero 2015",
    ogImage: `${Base_Url}/img/activities/warrant_hero_2015.jpg`,
  },
  {
    path: "/marketnews/activities/warrior/2017",
    element: <WarrantWarriors />,
    title: "Warrant Warrior 2017",
    ogType: "website",
    ogTitle: "Warrant Warrior 2017",
    ogDescription: "Warrant Warrior 2017",
    ogImage: `${Base_Url}/img/activities/warrant_warrior_2017.jpg`,
  },
];

export default warrantMarketRoutes;
